import Fetch from './fetch-service';

export async function fetchVerify() { // eslint-disable-line import/prefer-default-export
  const res = await Fetch('/azd/verify');
  if (!res.ok) { throw new Error(res); }
  return true;
}

export async function fetchProfile() {
  const res = await Fetch('/azd/aboutMe');
  if (!res.ok) { throw res.statusText; }
  return res.json();
}

export function logout() {
  return Fetch('/azd/logout').then((res) => {
    if (!res.ok) {
      throw res.statusText;
    }
    window.location = 'https://www.google.com/accounts/Logout?continue=https://appengine.google.com/_ah/logout?continue=https://bevillingkontroll.trondheim.kommune.no';
  });
}

export function fetchLicenses() {
  return Fetch('/azd/controllerapp/licenses-with-amb');
}

export function fetchAssignments() {
  return Fetch('/azd/controllerapp/assignments?fetchworkplans=true&fetchcontrols=true');
}

export function fetchControllers() {
  return Fetch('/azd/controllerapp/controllers');
}

export function fetchControl(sysID) {
  return Fetch(`/azd/controllerapp/control?sysid=${sysID}`);
}

export function fetchControls(licenseSysID, workPlanSysID) {
  let url = '/azd/controllerapp/controls';
  if (licenseSysID) {
    url += `?licensesysid=${licenseSysID}`;
  } else {
    url += `?workplansysid=${workPlanSysID}`;
  }
  return Fetch(url);
}

export function fetchReactions(licenseSysID) {
  return Fetch(`/azd/controllerapp/reaction-records?licensesysid=${licenseSysID}`);
}
